import { BTabs } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBTabs when migrating. */
export const EgBTabs = createEgBootstrapProxy("EgBTabs", BTabs);
